import { render, staticRenderFns } from "./facestatistics.vue?vue&type=template&id=1fda6063"
import script from "./facestatistics.vue?vue&type=script&lang=js"
export * from "./facestatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports